module.exports = __webpack_public_path__ + "img/IMG_9807.457de33a.jpg";